const DeviceType = {
  iPhone: "iphone",
  Android: "android",
  iPad: "ipad",
  Tablet: "tablet",
  MacBook: "macbook",
  Windows: "windows",
  Linux: "linux",
  Desktop: "desktop",
  Other: "other",
};

export default function getDeviceType(ua) {
  const userAgent =
    ua?.toLowerCase() ?? window?.navigator?.userAgent?.toLowerCase();

  const isIPhone = () => userAgent.includes("iphone");
  const isIPad = () => userAgent.includes("ipad");
  const isAndroid = () => userAgent.includes("android");
  const isTablet = () => userAgent.includes("tablet");
  const isMac = () =>
    userAgent.includes("macintosh") ||
    userAgent.includes("mac os x") ||
    userAgent.includes("mac");
  const isWindows = () =>
    userAgent.includes("windows") || userAgent.includes("win32");
  const isLinux = () =>
    userAgent.includes("linux") || userAgent.includes("ubuntu");

  const patterns = [
    { check: isIPad, type: DeviceType.iPad },
    { check: isIPhone, type: DeviceType.iPhone },
    { check: isAndroid, type: DeviceType.Android },
    { check: isMac, type: DeviceType.MacBook },
    { check: isWindows, type: DeviceType.Windows },
    { check: isTablet, type: DeviceType.Tablet },
    { check: isLinux, type: DeviceType.Linux },
  ];

  for (const { check, type } of patterns) {
    if (check()) {
      return { deviceType: type, device: type };
    }
  }

  return {
    deviceType: DeviceType.Other,
    device: DeviceType.Other,
  };
}
